// components/icons/ArrowIcon.tsx
import React from "react";

export default function ArrowIcon({
  color = "#000000",
  rotate = false,
}: {
  color?: string;
  rotate?: boolean;
}) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`transition-transform duration-300 ${rotate ? "rotate-90" : "rotate-0"}`}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M0.592529 3.70117H21.0117V24.1203"
          stroke={color}
          strokeWidth="5.97634"
          strokeMiterlimit="10"
        />
        <path
          d="M2.08643 22.1287L21.0115 3.70166"
          stroke={color}
          strokeWidth="5.97634"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="24"
            height="23.5568"
            fill="white"
            transform="translate(0 0.712891)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
